import PropTypes from 'prop-types';
import React from 'react';

import {
  FiltersRow,
  DragDropArea,
} from './components';
import { ACTIONS, MODULES } from '../../constants/pemissions';
import { ScrollWrapper, PermissionElement } from '../../ui-kit';
import './style.sass';

const Tasks = ({
  getTasks, onDragEnd, getFilter, projectTasksPendingRequest, scrollRestorationKey, projectId,
}) => (
  <div className="tasks">
    <PermissionElement
      module={MODULES.PROJECTS}
      action={ACTIONS.READ}
    >
      <ScrollWrapper
        className="tasks__scroll-wrapper"
        scrollRestorationKey={scrollRestorationKey}
      >
        <FiltersRow
          selectedAssignee={getFilter(null, 'assignee')}
          selectedAssigner={getFilter(null, 'created_by')}
          selectedSprintsStatus={getFilter(null, 'sprintsStatus')}
        />
        <DragDropArea
          getTasks={getTasks}
          onDragEnd={onDragEnd}
          isLoading={projectTasksPendingRequest}
          projectId={projectId}
        />
      </ScrollWrapper>
    </PermissionElement>
  </div>
);

Tasks.propTypes = {
  match: PropTypes.shape({}),
  getTasks: PropTypes.func.isRequired,
  onDragEnd: PropTypes.func.isRequired,
  getFilter: PropTypes.func.isRequired,
  projectTasksPendingRequest: PropTypes.bool.isRequired,
  scrollRestorationKey: PropTypes.string,
};

Tasks.defaultProps = {
  match: {},
  scrollRestorationKey: '',
};

export default Tasks;
